/**
 * 相关配置
 */

/**
 * ossUrl
 * use: import {ossUrl} from '@/utils/config'
 */
export const ossUrl = 'https://web.nlktj.com/ty/merchant/';

